import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Col, Row, Select } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import { toast } from 'react-toastify'

const { Option } = Select

const ClaimManagerForm = props => {
  const { form, ClaimManagerID, InsurerID, recordID, onSuccess, modalVisible } = props

  const { getFieldDecorator } = form
  const [loading, setLoading] = useState(false)
  const [claimManagerList, setClaimManagerList] = useState([])
  const [insurerList, setInsurerList] = useState([])
  const [recordId, setRecordId] = useState(0)

  useEffect(() => {
    fetchClaimManagers()
    fetchInsurers()
    if (ClaimManagerID && InsurerID) {
      form.setFieldsValue({
        claimManagerId: ClaimManagerID,
        insurerIds: InsurerID,
      })
      setRecordId(recordID)
    } else if (InsurerID) {
      form.setFieldsValue({
        insurerIds: InsurerID,
      })
    } else {
      form.resetFields()
    }
  }, [ClaimManagerID, modalVisible, InsurerID])

  const fetchInsurers = async () => {
    try {
      const insurers = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`,
        'GET'
      )
      setInsurerList(insurers?.data || [])
    } catch (err) {
      console.error('Error fetching insurers:', err)
    }
  }

  const fetchClaimManagers = async () => {
    try {
      const managers = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/claim-manager`,
        'GET'
      )
      setClaimManagerList(managers?.data || [])
    } catch (err) {
      console.error('Error fetching claim managers:', err)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)

      try {
        const selectedInsurer = insurerList.find(ins => ins.id === values.insurerIds)
        const selectedManager = claimManagerList.find(m => m.id === values.claimManagerId)

        if (!selectedInsurer || !selectedManager) {
          toast.error('Invalid Insurer or Claim Manager selected')
          setLoading(false)
          return
        }

        const payload = {
          AssignorId: selectedInsurer?.id,
          AssignorName: selectedInsurer?.name,
          childDto: [
            {
              AssigneeId: selectedManager?.id,
              AssigneeName: selectedManager?.name
            }
          ],
          id: recordId
        }

        const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/AssignedSubordinates`

        const res = await apiRequest(url, 'POST', payload)
        if (res.success) {
          if (res.data?.success) {
            toast.success(ClaimManagerID ? 'Claim Manager Updated!' : 'Claim Manager Assigned!')
            onSuccess()
          } else {
            toast.error(res.data.message || 'Something went wrong')
          }
        } else {
          toast.error(res.error || 'Something went wrong')
        }
      } catch (err) {
        console.error('Submit error:', err)
        toast.error('Request failed, try again.')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select Insurer">
                {getFieldDecorator('insurerIds', {
                  rules: [{ required: true, message: 'Please select an insurer' }],
                })(
                  <Select placeholder="Select Insurer">
                    {insurerList?.map(ins => (
                      <Option key={ins?.id} value={ins?.id}>
                        {ins?.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Claim Manager">
                {getFieldDecorator('claimManagerId', {
                  rules: [{ required: true, message: 'Please select a claim manager' }],
                })(
                  <Select placeholder="Select Claim Manager">
                    {claimManagerList?.map(m => (
                      <Option key={m.id} value={m.id}>
                        {m.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              {ClaimManagerID ? 'Update Claim Manager' : 'Assign Claim Manager'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(ClaimManagerForm)
